import React, { useState, useEffect } from 'react'
import HeadingArea from '../../general/HeadingArea'
import { FaCheck } from 'react-icons/fa6';
import ResponseMsg2 from '../../general/ResponseMsg2';
import { RiDeleteBin6Line } from 'react-icons/ri';

const QuestionBank = ({ setLoading }) => {
  const [classes, setClasses] = useState([]);
  const [selectedClassId, setSelectedClassId] = useState('');
  const [questionType, setQuestionType] = useState('');
  const [numOptions, setNumOptions] = useState(0);
  const [options, setOptions] = useState([]);
const [group, setGroup] = useState('');
const [questionText, setQuestionText] = useState('');
const [marks, setMarks] = useState('');
const [groups, setGroups] = useState([]);
  const [theoryAnswer, setTheoryAnswer] = useState('');
  const [subjects, setSubjects] = useState([]);
  const [selectedSubject, setSelectedSubject] = useState('');
  const [response2, setResponse2] = useState({ message: '', status: '' });
const [questions, setQuestions] = useState([]);
const [searchTerm, setSearchTerm] = useState('');
const [showDelete, setShowDelete] = useState(false);
const [selectedQues, setSelectedQues] = useState('');



  const fetchClasses = async () => {
    setLoading(true);
    try {
      const response = await fetch('https://api.kcian.in/get-classes');
      if (response.ok) {
        const data = await response.json();
        setClasses(data);
      } else {
        console.error('Failed to fetch class');
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
    setLoading(false);
  }


                 const fetchGroup = async () => {
                            setLoading(true);
                    try {
                        const response = await fetch('https://api.kcian.in/get-quesgroup');
        
                        if (response.ok) {
                            const data = await response.json();
const grpList = data.map(item => item.ques_group);
                            setGroups(grpList);
                            setLoading(false);
                        } else {
                            setLoading(false);
                            console.error('Failed to fetch');
                        }
                    } catch (error) {
                        setLoading(false);
                        console.error('Error fetching data:', error);
                    }
      }


  useEffect(() => {
    fetchClasses();
    fetchGroup();
  }, []);


    const fetchAssignSubject = async (classId) => {
    if (!classId) return;
    setLoading(true);
    try {
      const res = await fetch(`https://api.kcian.in/fetch-assigned-subject?class_id=${classId}`);
      if (res.ok) {
        const data = await res.json();
        if (data.length > 0) {
          const uniqueSubjectsMap = new Map();
          data.forEach(item => {
            if (!uniqueSubjectsMap.has(item.sub_id)) {
              uniqueSubjectsMap.set(item.sub_id, item);
            }
          });
          const uniqueSubjects = Array.from(uniqueSubjectsMap.values());
          setSubjects(uniqueSubjects);
          setResponse2({ message: 'Subjects Loaded.', status: 'success' });
        } else {
          setSubjects([]);
          setResponse2({ message: 'No subjects assigned to this class.', status: 'error' });
        }
      } else {
        setSubjects([]);
        setResponse2({ message: 'Error fetching subjects.', status: 'error' });
      }
    } catch (error) {
      console.error('Error fetching assigned subjects:', error);
    } finally {
      setLoading(false);
      setTimeout(() => setResponse2({ message: '', status: '' }), 3000);
    }
  };

  useEffect(() => {
    if (selectedClassId) {
      fetchAssignSubject(selectedClassId);
    } else {
      setSubjects([]);
    }
  }, [selectedClassId]);

  // Handle change in number of options input
  const handleNumOptionsChange = (e) => {
    const val = parseInt(e.target.value, 10);
    if (!isNaN(val) && val >= 0) {
      setNumOptions(val);
    } else {
      setNumOptions(0);
    }
  }

  // Create option inputs when "Create Options" clicked
  const createOptions = () => {
    const newOptions = [];
    for (let i = 0; i < numOptions; i++) {
      newOptions.push({ text: '', isCorrect: false });
    }
    setOptions(newOptions);
  }

  // Update option text
  const updateOptionText = (index, text) => {
    const newOptions = [...options];
    newOptions[index].text = text;
    setOptions(newOptions);
  }


  const selectCorrectOption = (index) => {
  const newOptions = options.map((opt, idx) => ({
    ...opt,
    isCorrect: idx === index,
  }));
  setOptions(newOptions);
}

  // Reset options when question type changes
  useEffect(() => {
    setOptions([]);
    setNumOptions(0);
    setTheoryAnswer('');
  }, [questionType]);


const handleGroupChange = (e) => {
  if (e.target.value === 'add-new') {
    const newGroup = prompt('Enter new group name');
    if (newGroup) {
      setGroups([...groups, newGroup]);
      setGroup(newGroup);
    }
  } else {
    setGroup(e.target.value);
  }
}


const handleSave = async (e) => {
  e.preventDefault();

  // For MCQ, find the correct option's text
  let correct_ans = null;
  if (questionType === 'MCQ') {
    const correctOption = options.find(opt => opt.isCorrect);
    correct_ans = correctOption ? correctOption.text : null;
  } else if (questionType === 'Theory') {
    correct_ans = theoryAnswer;
  }

  const payload = {
    ques_group: group,
    class_id: selectedClassId,
    sub_id: selectedSubject,
    ques_type: questionType,
    ques: questionText,
    marks: Number(marks),
    options: questionType === 'MCQ' ? options : null,
    correct_ans: correct_ans,
  };

  setLoading(true);
  try {
    const response = await fetch('https://api.kcian.in/add-question', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });

    if (response.ok) {
          setResponse2({ message: 'Question Added Successfully', status: 'success' });

      // Reset form
      setGroup('');
      setSelectedClassId('');
      setSelectedSubject('');
      setQuestionType('');
      setNumOptions(0);
      setOptions([]);
      setTheoryAnswer('');
      setQuestionText('');
      setMarks('');
    } else {
      const err = await response.text();
      setResponse2({ message: 'Something Went Wrong. Please try again.', status: 'error' });
    }
  } catch (error) {
    console.log(error);
  }
    setTimeout(() => setResponse2({ message: '', status: '' }), 3000);
  setLoading(false);
}


const fetchQuestions = async () => {
  if (!selectedClassId || !selectedSubject) return;  // Use selectedClassId and selectedSubject here
  setLoading(true);

  try {
    const res = await fetch(`https://api.kcian.in/get-quesbank?class_id=${selectedClassId}&sub_id=${selectedSubject}`);
    if (res.ok) {
      const data = await res.json();
      console.log(data);
      setQuestions(data);
    } else {
      setQuestions([]);
      setResponse2({ message: 'No Questions Added.', status: 'error' });
      console.error('Failed to fetch questions');
    }
  } catch (error) {
    console.error('Error fetching questions:', error);
    setQuestions([]);
  }

  setTimeout(() => setResponse2({ message: '', status: '' }), 3000);
  setLoading(false);
};


      const filteredQues = questions.filter(q => {
  const term = searchTerm.toLowerCase();
  return (
    q.class_name.toLowerCase().includes(term) ||
    q.sub_name.toLowerCase().includes(term) ||
    q.ques_type.toLowerCase().includes(term)
  );
});

    const handleShowDelete = (book) => {
    setSelectedQues(book);
    setShowDelete(true);
  }


              const handleDelete = async (qId) => {
    try {
      const response = await fetch(`https://api.kcian.in/delete-ques/${qId}`, {
        method: 'DELETE',
      });


      if (response.ok) {
setQuestions((prevData) => prevData.filter((product) => product.id !== qId));
        setShowDelete(false);
        setResponse2({ message: 'Question Removed from Bank!', status: 'success' });
        setTimeout(() => {
          setResponse2('');
        }, 3000);
      } else {
                setResponse2({ message: 'Something Went Wrong. Please try again.', status: 'error' });
        setTimeout(() => {
          setResponse2('');
        }, 3000);   
      }
    } catch (error) {
      console.error('Error deleting:', error);
    }
  };


  return (
    <>

    <section className='py-4'>
      <div className='px-4'>
        <HeadingArea message1="Online Exam" message2="Question Bank" />
        <div className='row'>

<div className='px-3'>
        {response2.message && <ResponseMsg2 message={response2.message} status={response2.status} />}
</div>

          <div className='col-xl-3 col-lg-4 col-md-5 col-12 my-2'>
            <div className="profile-card">
              <p className="profile-heading mb-4">Add Question Bank</p>

<form onSubmit={handleSave}>

              {/* Group */}
              <div className='profile-input-area mb-4'>
                <label className='profile-badge'>Group*</label>
<select name='Group' className='profile-input' value={group} onChange={handleGroupChange} required>
  <option value=''>Select Group..</option>
  {groups.map((grp, idx) => (
    <option key={idx} value={grp}>{grp}</option>
  ))}
  <option value='add-new'>Add New Group</option>
</select>
              </div>

              {/* Class */}
              <div className='profile-input-area mb-4'>
                <label className='profile-badge'>Class*</label>
                <select
                  className="profile-input"
                  value={selectedClassId}
                  onChange={(e) => setSelectedClassId(e.target.value)}
                  required
                >
                  <option value="">-- Select Class --</option>
                  {classes.map((cls) => (
                    <option key={cls.id} value={cls.id}>
                      {cls.class_name}
                    </option>
                  ))}
                </select>
              </div>

                <div className='profile-input-area mb-4'>
                  <label className='profile-badge'>Subject</label>
                  <select
                    className='profile-input'
                    value={selectedSubject}
                    onChange={(e) => setSelectedSubject(e.target.value)}
                    disabled={subjects.length === 0}
                    required
                  >
                    <option value=''>-- Select Subject --</option>
                    {subjects.map(sub => (
                      <option key={sub.id} value={sub.sub_id}>
                        {sub.sub_name} ({sub.sub_type}) ({sub.sub_code})
                      </option>
                    ))}
                  </select>
                </div>


              {/* Question Type */}
              <div className='profile-input-area mb-4'>
                <label className='profile-badge'>Question Type*</label>
                <select
                  name='Type'
                  className='profile-input'
                  required
                  value={questionType}
                  onChange={(e) => setQuestionType(e.target.value)}
                >
                  <option value=''>Select Type..</option>
                  <option value='MCQ'>MCQ</option>
                  {/* <option value='Theory'>Theory</option> */}
                </select>
              </div>

              {/* Question */}
{/* Question */}
<div className="profile-input-area mb-4">
  <label htmlFor="questionText" className="profile-badge" required>
    Question
  </label>
  <textarea
    id="questionText"
    name="questionText"
    className="profile-input"
    value={questionText}
    onChange={(e) => setQuestionText(e.target.value)}
    required
  />
</div>

              {/* Marks */}
{/* Marks */}
<div className='profile-input-area mb-4'>
  <label className='profile-badge'>Marks *</label>
  <input
    name='Marks'
    className='profile-input'
    type='number'
    value={marks}
    onChange={(e) => setMarks(e.target.value)}
    required
  />
</div>


              {/* Conditional Rendering based on question type */}
              {questionType === 'MCQ' && (
                <>
                <div className='d-flex'>
                  <div className='profile-input-area me-2'>
                    <label className='profile-badge'>Number of Options</label>
                    <input
                      type="number"
                      min={0}
                      value={numOptions}
                      onChange={handleNumOptionsChange}
                      className='profile-input'
                      placeholder='Enter number of options'
                    />
                  </div>
                  <div className='align-content-center'>
                    <button
                      type='button'
                      className='profile-btn'
                      onClick={createOptions}
                      disabled={numOptions <= 0}
                    >
                      Create
                    </button>
                  </div>
                  </div>

{options.length > 0 && options.map((opt, idx) => (
  <div key={idx} className="d-flex align-items-center mt-3">
    <div className='profile-input-area'>
      <input
        type="text"
        className='profile-input'
        placeholder={`Option ${idx + 1}`}
        value={opt.text}
        onChange={(e) => updateOptionText(idx, e.target.value)}
      />
    </div>
    <input
      type="radio"
      name="correctOption"
      className='ms-2'
      checked={opt.isCorrect}
      onChange={() => selectCorrectOption(idx)}
      title="Mark as correct"
    />
  </div>
))}

                </>
              )}

              {questionType === 'Theory' && (
                <div className="profile-input-area">
                  <label htmlFor="theoryAnswer" className="profile-badge">Answer</label>
                  <textarea
                    id="theoryAnswer"
                    name="theoryAnswer"
                    className="profile-input"
                    value={theoryAnswer}
                    onChange={(e) => setTheoryAnswer(e.target.value)}
                    placeholder="Enter theory answer here"
                  />
                </div>
              )}

              {/* button */}
              <div className='text-center mt-4'>
                <button type='submit' className='profile-btn'>
                  <FaCheck /> Save
                </button>
              </div>

</form>

            </div>
          </div>

          {/* table */}
          <div className='col-xl-9 col-lg-8 col-md-7 col-12 my-2 h-100'>
            <div className='profile-card'>

              <div className='d-md-flex justify-content-between'>
                <span className="profile-heading align-content-center">Question Bank List</span>


<div className='d-md-flex d-block'>

              <div className='profile-input-area my-4 me-2'>
                <label className='profile-badge'>Class*</label>
                <select
                  className="profile-input"
                  value={selectedClassId}
                  onChange={(e) => setSelectedClassId(e.target.value)}
                  required
                >
                  <option value="">-- Select Class --</option>
                  {classes.map((cls) => (
                    <option key={cls.id} value={cls.id}>
                      {cls.class_name}
                    </option>
                  ))}
                </select>
              </div>

                <div className='profile-input-area my-4 me-2'>
                  <label className='profile-badge'>Subject</label>
                  <select
                    className='profile-input'
                    value={selectedSubject}
                    onChange={(e) => setSelectedSubject(e.target.value)}
                    disabled={subjects.length === 0}
                    required
                  >
                    <option value=''>-- Select Subject --</option>
                    {subjects.map(sub => (
                      <option key={sub.id} value={sub.sub_id}>
                        {sub.sub_name} ({sub.sub_type}) ({sub.sub_code})
                      </option>
                    ))}
                  </select>
                </div>


  <div className="col-md-4 align-content-center">
    <button className="profile-btn" onClick={fetchQuestions}>
      Get Ques
    </button>
  </div>
</div>

              </div>
              

                                          <div className='profile-input-area ms-auto col-lg-4 border-0'>
<input
  type='text'
  name='search'
  className='profile-input border-bottom rounded-0'
  placeholder='Search Class, Subject, Ques Type'
  value={searchTerm}
  onChange={(e) => setSearchTerm(e.target.value)}
/>
                            </div>

              <div className='table-responsive'>
                <table className='w-100'>

                  <thead className='account-thead'>
                    <th className='rounded-start-4'>S No</th>
                    <th>Group</th>
                    <th>Class</th>
                    <th>Question</th>
                    <th>Type</th>
                    <th>Options</th>
                    <th>Correct Ans</th>
                    <th className='rounded-end-4'>Action</th>
                  </thead>

                      {filteredQues.map((q, index) => (
                        <tr className='account-tr' key={q.id}>
                          <td>{index + 1}</td>
                          <td>{q.ques_group}</td>
                          <td>{q.class_name}</td>
                          <td>{q.ques || '--'}</td>
                          <td>{q.ques_type || '--'}</td>
<td className='text-nowrap'>
  {q.ques_type === 'MCQ' && q.options ? (
    typeof q.options === 'string' ? (
      JSON.parse(q.options).map((opt, idx) => (
        <div key={idx}>
          {String.fromCharCode(65 + idx)}. {opt.text}
        </div>
      ))
    ) : (
      q.options.map((opt, idx) => (
        <div key={idx}>
          {String.fromCharCode(65 + idx)}. {opt.text}
        </div>
      ))
    )
  ) : (
    '--'
  )}
</td>
                          <td>{q.correct_ans || '--'}</td>
                          <td>
                            <RiDeleteBin6Line className='account-icon1' onClick={() => handleShowDelete(q)} />
                          </td>
                        </tr>
                      ))}
                  
                  
                </table>
              </div>

            </div>
          </div>

        </div>
      </div>
    </section>


          {showDelete && (
  <>
        <section className='ins-dialog'>
          <div className='ins-dialog-inner col-lg-10 col-12 animate__animated animate__fadeInDown mx-auto' onClick={(e) => e.stopPropagation()}>

            <p className='ins-dialog-heading text-danger'>Remove This Question!</p>

<div className='table-responsive'>
<table className='w-100'>

<thead className='account-thead'>
      <th className='rounded-start-4'>Group</th>
                    <th>Class</th>
                    <th>Question</th>
                    <th>Type</th>
                    <th>Options</th>
      <th className='rounded-end-4'>Correct Ans</th>
</thead>

<tr className='account-tr'>
                          <td>{selectedQues.ques_group}</td>
                          <td>{selectedQues.class_name}</td>
                          <td>{selectedQues.ques || '--'}</td>
                          <td>{selectedQues.ques_type || '--'}</td>
                          
<td className='text-nowrap'>
  {selectedQues.ques_type === 'MCQ' && selectedQues.options ? (
    typeof selectedQues.options === 'string' ? (
      JSON.parse(selectedQues.options).map((opt, idx) => (
        <div key={idx}>
          {String.fromCharCode(65 + idx)}. {opt.text}
        </div>
      ))
    ) : (
      selectedQues.options.map((opt, idx) => (
        <div key={idx}>
          {String.fromCharCode(65 + idx)}. {opt.text}
        </div>
      ))
    )
  ) : (
    '--'
  )}
</td>

                          <td>{selectedQues.correct_ans || '--'}</td>
</tr>

</table>
</div>

<p className='para-text mt-3'>Note: This action cannot be undone. Once deleted, the Question will be permanently removed.</p>

            <button className='profile-btn me-2' onClick={() => handleDelete(selectedQues.id)}>Remove</button>
            <button className='profile-btn2' onClick={() => setShowDelete(false)}>Go Back</button>


    </div>
  </section>
  </>
)}
</>

  )
}

export default QuestionBank;
